import { LOCALES } from 'i18n/locales';

export const networkCoverageSnackBarIntl = {
    [LOCALES.ENGLISH]: {
        'networkCoverageSnackBar.alert': 'This page displays your coverage area and a list of asset owners who may have assets in that area. For further help, please visit our <link> help and guidance documentation.</link> Please note: for users based in both GB and NI, the coverage map will display only the currently selected region.',
        'networkCoverageSnackBar.notification.label': 'Network coverage help'
    },
    [LOCALES.WELSH]: {
        'networkCoverageSnackBar.alert': '[This page displays your coverage area and a list of asset owners who may have assets in that area.  Am ragor o help, ewch i\'n <link> dogfennaeth help a chyfarwyddyd.</link> Please note: for users based in both GB and NI, the coverage map will display only the currently selected region.]',
        'networkCoverageSnackBar.notification.label': 'Help cwmpas rhwydwaith'
    }
};
